import '../Cash';
import { ValidatorFactory } from './Validators'
  
window.addEventListener("load", function (event) {
    Array.from(document.querySelectorAll('form[data-validator]')).forEach((form: HTMLFormElement) => {
        let validatorList = form.dataset.validator.split(" ");
        validatorList.forEach(validator => {
            new ValidatorFactory(validator, form as HTMLFormElement);
        });
    })
});
